import { api } from "@/app/app.api";
import { objectToFormData } from "@/shared/utils/data";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake } from "caseparser";

export const transactionsApi = api
  .enhanceEndpoints({ addTagTypes: ["contract-clauses"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      contractsClauses: builder.mutation({
        query: ({ branchId, contract, clauses }) => ({
          url: `branchs/${branchId}/files`,
          method: RequestMethod.POST,
          body: objectToFormData(
            camelToSnake({
              branchId,
              contract,
              clauses,
            })
          ),
          formData: true,
        }),
        invalidatesTags: ["contract-clauses"],
      }),
      createContractsClauses: builder.mutation({
        query: ({ branchId, contrate, clauses }) => ({
          url: `branchs/${branchId}/files`,
          method: RequestMethod.POST,
          body: objectToFormData(
            camelToSnake({
              branchId,
              contrate,
              clauses,
            })
          ),
          formData: true,
        }),
        invalidatesTags: ["contract-clauses"],
      }),
    }),
  });

export const {
  useContractsClausesMutation,
  useCreateContractsClausesMutation,
} = transactionsApi;
